export default (value, max = 0) => max > 1 && value.length > max - 1 ? value.slice(0, max - 1) + "…": value
